import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const LogsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/logs/stripe',
      component: FuseLoadable({
        loader: () => import('./Logs')
      })
    },
    {
      path: '/logs/crm',
      component: FuseLoadable({
        loader: () => import('./LogsCrm')
      })
    }
  ]
}
